module.exports = __webpack_public_path__ + "media/images/listing-workflow-fdd58a127b18511fdea61fe7078ba86b.svg";